<template>
    <div>
        <div 
            class="list-group form-group form-control"
            :class="{ 'is-invalid' : errors && Object.keys(errors).length > 0 }"
        >
            <form-error
                field="pickup_point_id"
                :errors="errors"
            />
        </div>
        <vue-friendly-iframe :src="sprinterUrl" />
        <div
            v-if="selectedShop"
            class="mt-2"
        >
            A kiválasztott bolt kódja: {{ selectedShop.shopCode }}
        </div>
    </div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
export default {
    name: 'PickPackPoint',
    props: {
        pickupPoints: {
            type: Array,
            required: true
        },
        pickupPoint: {
            type: Number,
            default: null
        },
        errors: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            sprinterUrl: 'https://online.sprinter.hu/terkep/#/',
            selectedShop: null,
        }
    },
    mounted() {
        window.addEventListener('message', this.receiveMessage, false)
    },
    methods: {
        receiveMessage(event) {
            try {
                const data = JSON.parse(event.data)

                if (! data.hasOwnProperty('shopCode')) {
                    return
                }

                this.selectedShop = data
                this.$emit('input', this.convertShopCodeToId(data.shopCode))
            } catch (exception) {
                // The event.data is not always a valid json...
            }
        },

        convertShopCodeToId(shopCode) {
            const code = parseInt(shopCode)

            if (isNaN(code)) {
                return null
            }

            const point = this.pickupPoints.find(point => point.externalId == code)

            if (! point) {
                return null
            }

            return point.id
        }
    }
}
</script>

<style scoped>
.vue-friendly-iframe >>> iframe {
  width: 100%;
  height: 500px;
}

.list-group.form-control {
  border: none;
  display: none;
  background: none;
}

.list-group.form-control.is-invalid {
  display: inline-table;
}

.is-invalid > .invalid-feedback {
  display: block;
}
</style>
